// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--aUOuD","content":"_0d624b9a27--content--jSSeR","phone":"_0d624b9a27--phone--StF5U"};